<div class="bottom-sheet-content" #gestureArea>
  <div class="sheet-header">
    <div class="handle-bar"></div>
    <div class="back-button" (click)="cancel()" (keydown)="cancel()" tabindex="0">
      <img src="assets/ic-close.svg" alt="cancel icon" />
    </div>
  </div>

  <div class="title section-title-container">
    <h2>Switch Business</h2>
    <ion-note>Select which business to manage</ion-note>
  </div>

  <div class="business-list">
    <ion-list lines="none">
      @for (business of permittedBusinesses; track business) {
        <ion-item
          button
          (click)="selectBusiness(business)"
          [disabled]="isSwitching"
          [class.selected]="business.id === currentBusinessId"
          >
          <div class="business-item">
            <div class="image-wrapper square small">
              @if (!imageLoadedMap[business.id ?? 0] && business.avatarUrl) {
                <ion-skeleton-text animated></ion-skeleton-text>
              }
              <ion-img
                [alt]="business.name + ' logo'"
                [src]="business.avatarUrl || 'assets/ic-business.svg'"
                (ionImgDidLoad)="onImageLoad(business.id ?? 0)"
                [class.hidden]="!imageLoadedMap[business.id ?? 0] && business.avatarUrl"
                [class.fade-in]="business.avatarUrl"
              ></ion-img>
            </div>
            <div class="business-info">
              <ion-label>
                <h3>{{ business.name }}</h3>
                @if (business.city && business.state) {
                  <p>{{ business.city }}, {{ business.state }}</p>
                }
              </ion-label>
            </div>
            @if (business.id === currentBusinessId) {
              <ion-icon
                name="checkmark-circle"
                color="primary"
                class="selected-icon"
              ></ion-icon>
            }
          </div>
        </ion-item>
      }
    </ion-list>
  </div>

  @if (isSwitching) {
    <div class="action-footer">
      <ion-spinner name="crescent"></ion-spinner>
      <ion-text color="medium">Switching business...</ion-text>
    </div>
  }
</div>

